import { render, staticRenderFns } from "./PostDelivery.vue?vue&type=template&id=643a8be8"
import script from "./PostDelivery.vue?vue&type=script&lang=js"
export * from "./PostDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports